import { IdGenerator } from "./idGenerator";

export class ClaimHelper {
  static readonly DEFAULT_PREFIX = "CLAIM";

  static generateClaimId(vendorName?: string): string {
    const prefix = vendorName?.trim() || ClaimHelper.DEFAULT_PREFIX;

    const prefixParts = prefix.split(/\s+/).filter((part) => part.length);

    const firstPart = prefixParts[0].slice(0, 3).toUpperCase();

    const sixDigitId = IdGenerator.generate6DigitId();

    return `${ClaimHelper.DEFAULT_PREFIX}-${firstPart}-${sixDigitId}`;
  }
}
